module.exports = __webpack_public_path__ + "static/front-05d68d07ebd62a618de8b4f7a511e224.png";